import React, { useMemo, useState } from "react";

declare const require: {
  context: (
    path: string,
    deep?: boolean,
    filter?: RegExp
  ) => {
    keys: () => string[];
    (id: string): string;
  };
};

type GalleryImage = {
  src: string;
  alt: string;
};

const buildAltFromFileName = (fileName: string): string => {
  const cleanName = fileName
    .replace(/^\.\//, "")
    .replace(/\.[^/.]+$/, "")
    .replace(/[-_]+/g, " ")
    .trim();

  return cleanName || "Výrobek";
};

const Work: React.FC = () => {
  const images = useMemo<GalleryImage[]>(() => {
    const galleryContext = require.context(
      "../assets/vyrobky",
      false,
      /\.(png|jpe?g|webp|gif|svg)$/i
    );

    return galleryContext.keys().map((key) => ({
      src: galleryContext(key),
      alt: buildAltFromFileName(key)
    }));
  }, []);

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const openModal = (index: number): void => {
    setActiveIndex(index);
  };

  const closeModal = (): void => {
    setActiveIndex(null);
  };

  const showNext = (): void => {
    if (activeIndex === null || images.length === 0) {
      return;
    }

    setActiveIndex((activeIndex + 1) % images.length);
  };

  const showPrevious = (): void => {
    if (activeIndex === null || images.length === 0) {
      return;
    }

    setActiveIndex((activeIndex - 1 + images.length) % images.length);
  };

  return (
    <section className="page-section work-gallery-page">
      <h3>Prohlédněte si ukázky zakázkové výroby</h3>

      {images.length === 0 ? (
        <p className="gallery-empty">
          Ve složce /assets/vyrobky zatím nejsou žádné fotografie.
        </p>
      ) : (
        <div className="gallery-grid" aria-label="Galerie výrobků">
          {images.map((image, index) => (
            <button
              key={image.src}
              type="button"
              className="gallery-thumb"
              onClick={() => openModal(index)}
              aria-label={`Otevřít fotografii ${index + 1}`}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
            </button>
          ))}
                          
        </div>
        
        
      )}

      <p style={{ marginTop: "1rem", fontStyle: "italic", textAlign: "center" }}>
        Kliknutím na fotografii otevřete detail a šipkami se můžete posouvat mezi jednotlivými realizacemi.
      </p>

      {activeIndex !== null && images[activeIndex] && (
        <div className="gallery-modal" role="dialog" aria-modal="true" onClick={closeModal}>
          <div className="gallery-modal-content" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="gallery-arrow gallery-arrow-left"
              onClick={showPrevious}
              aria-label="Předchozí fotografie"
            >
              &#8249;
            </button>

            <img src={images[activeIndex].src} alt={images[activeIndex].alt} className="gallery-large" />

            <button
              type="button"
              className="gallery-arrow gallery-arrow-right"
              onClick={showNext}
              aria-label="Další fotografie"
            >
              &#8250;
            </button>

            <button
              type="button"
              className="gallery-close"
              onClick={closeModal}
              aria-label="Zavřít galerii"
            >
              ×
            </button>
          </div>

        </div>
      )}
    </section>
  );
};

export default Work;
